import { Entity } from 'engine/Entity';
import { getDistance } from 'engine/lib/V2';
import { MAX_NEARBY_DISTANCE } from 'game/config';
import { BotEntity } from 'game/entities/BotEntity';
import { PlantEntity } from 'game/entities/PlantEntity';
import { PlayerEntity } from 'game/entities/PlayerEntity';
import { TreeEntity } from 'game/entities/TreeEntity';
import { WaterSource } from 'game/entities/WaterSource';
import { NearbyModule, NearbySelection, determineNearbySelection } from 'game/state/BotState';
import { Processor } from '../Processor';

export const nearbyProcessor: Processor<NearbyModule> = (module, ctx) => {
  const { engine } = ctx;
  const { modules } = ctx.bot.props.state;
  let matches: Entity[] = [];
  let selection = module.config.manualSelection;
  if (module.inputs.item) {
    const itemModule = modules.find(m => m.id === module.inputs.item?.moduleId);
    if (itemModule) {
      const itemResult = ctx.processOther(itemModule, ctx);
      if (itemResult.status !== 'success') {
        return { status: 'null' };
      }
      selection = determineNearbySelection(itemModule, ctx.bot.props.state);
    }
  }
  switch (selection) {
    case NearbySelection.DryPlant: {
      matches = engine.entities.filter(e => e instanceof PlantEntity && e.props.waterAmount < 1);
      break;
    }
    case NearbySelection.Tree: {
      matches = engine.entities.filter(e => e instanceof TreeEntity && !e.props.treeState.chopped);
      break;
    }
    case NearbySelection.Water: {
      matches = engine.entities.filter(e => e instanceof WaterSource);
      break;
    }
    case NearbySelection.Human: {
      matches = [engine.entities.find(e => e instanceof PlayerEntity)!];
      break;
    }
    case NearbySelection.Bot: {
      matches = engine.entities.filter(e => {
        return e instanceof BotEntity && e !== ctx.bot.entity && !e.props.state.didDie;
      });
    }
  }
  const { position } = ctx.bot.props.state;
  const matchesWithDistance = matches.map(entity => ({
    entity,
    distance: getDistance(position, entity.transform.position),
  }));
  const [closest] = matchesWithDistance
    .filter(f => f.distance <= MAX_NEARBY_DISTANCE)
    .sort((a, b) => a.distance - b.distance);
  if (closest) {
    return { status: 'success', moduleId: module.id, value: { type: 'entity', entity: closest.entity } };
  }
  return { status: 'null' };
};
